import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Blog.css';

function formatDate(iso) {
    if (!iso) return '';
    return new Date(iso).toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
}

const Blog = () => {
    const { user } = useAuth();
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        setLoading(true);
        setError('');
        fetch('/api/blog', { credentials: 'include' })
            .then(r => {
                if (!r.ok) throw new Error('Failed to load blog posts');
                return r.json();
            })
            .then(data => setPosts(data))
            .catch(err => setError(err.message))
            .finally(() => setLoading(false));
    }, [user]);

    return (
        <div className="blog">
            <div className="blog-header">
                <h1>Blog</h1>
                {user?.is_admin && (
                    <Link to="/admin/blog" className="blog-back-button">
                        Manage posts
                    </Link>
                )}
            </div>

            {loading && <p>Loading posts…</p>}
            {error && <div className="alert-error">{error}</div>}

            {!loading && !error && posts.length === 0 && (
                <p className="blog-empty">No posts yet.</p>
            )}

            {!loading && !error && posts.length > 0 && (
                <ul className="blog-list">
                    {posts.map(post => (
                        <li key={post.id} className="blog-list-item">
                            {post.restricted ? (
                                <Link to={`/blog/${post.slug}`}>
                                    <h2>{post.title}</h2>
                                    <div className="blog-list-meta">
                                        <span>{formatDate(post.published_at)}</span>
                                        {post.author_username && <span>by {post.author_username}</span>}
                                        <span className="blog-badge blog-badge-members">Members only</span>
                                    </div>
                                    <p className="blog-restricted-note">
                                        {user ? 'Open to read.' : 'Log in to read this post.'}
                                    </p>
                                </Link>
                            ) : (
                                <Link to={`/blog/${post.slug}`}>
                                    <h2>{post.title}</h2>
                                    <div className="blog-list-meta">
                                        <span>{formatDate(post.published_at)}</span>
                                        {post.author_username && <span>by {post.author_username}</span>}
                                        {post.visibility === 'members' && (
                                            <span className="blog-badge blog-badge-members">Members only</span>
                                        )}
                                    </div>
                                    {post.excerpt && <p className="blog-excerpt">{post.excerpt}</p>}
                                </Link>
                            )}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default Blog;
